import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Avatar } from "./StaffAvatar";

const Star = ({ s, me }) => (
  <div className={`flex items-center gap-3 p-3 border bg-card/70 min-w-0 ax-cheer ${s.user_id === me ? "border-primary" : ""}`} data-testid={`home-weekly-star-${s.user_id}`}>
    <div className="relative shrink-0"><Avatar name={s.staff_name || s.name} size={44} />
      <Trophy className="h-4 w-4 absolute -bottom-1 -right-1 drop-shadow" style={{ color: "#d4a017" }} /></div>
    <div className="min-w-0">
      <div className="font-semibold truncate text-sm" data-testid={`home-weekly-star-name-${s.user_id}`}>{s.user_id === me ? "You!" : s.name}</div>
      <div className="text-xs text-muted-foreground num" data-testid={`home-weekly-star-score-${s.user_id}`}>{s.pct}% on time · {s.on} of {s.total}</div>
    </div>
  </div>
);

const Branch = ({ b, me }) => (
  <div className="min-w-0" data-testid={`home-weekly-star-branch-${b.branch}`}>
    <div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1.5">{b.branch_name}</div>
    {b.stars.length ? <div className="space-y-2">{b.stars.map((s) => <Star key={s.user_id} s={s} me={me} />)}</div>
      : <p className="text-xs text-muted-foreground p-3 border border-dashed">No star this week. 10 items due is the entry ticket.</p>}
  </div>
);

export const LandingStar = () => {
  const { can } = useAuth();
  return can("sales", "read") ? null : <WeeklyStar />;
};

export const WeeklyStar = () => {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/home/weekly-star").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="ax-panel p-4 mb-6 ax-fade" style={{ background: "#fffbea" }} data-testid="home-weekly-star">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 font-semibold mb-1"><Trophy className="h-5 w-5" style={{ color: "#d4a017" }} />Weekly Follow-up Stars
        <span className="text-xs font-normal text-muted-foreground" data-testid="home-weekly-star-week">{d.week}</span></div>
      <p className="text-xs italic text-muted-foreground mb-3" data-testid="home-weekly-star-line">{d.line}</p>
      <div className="grid sm:grid-cols-2 gap-4">{d.branches.map((b) => <Branch key={b.branch} b={b} me={user?.user_id} />)}</div>
    </div>
  );
};
